import { Switch } from '@headlessui/react';
import React from 'react';

interface Props {
  checked: boolean;
  label: string;
  description?: string;
  onChange: (checked: boolean) => void;
  value: string;
}

export const ToggleSwitch: React.FC<Props> = (props) => {
  return (
    <div className="space-y-3">
      <Switch.Group as="div" className="flex items-center justify-between">
        <Switch.Label className="mr-4 cursor-pointer flex-1">
          {props.label}
        </Switch.Label>
        <Switch
          checked={props.checked}
          onChange={props.onChange}
          value={props.value}
          className={`${
            props.checked ? 'bg-primary-500' : 'bg-grey-200'
          } relative inline-flex items-center h-7 rounded-full w-12 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-300 focus:ring-opacity-60`}
        >
          <span
            className={`${
              props.checked ? 'translate-x-6' : 'translate-x-1'
            } inline-block w-5 h-5 transform bg-white rounded-full transition-transform`}
          />
        </Switch>
      </Switch.Group>
      {props.description ? (
        <p className="text-xs text-grey-500">{props.description}</p>
      ) : null}
    </div>
  );
};
